import React from 'react'
import { GetDeliveryAreasReq } from '@/services/deliveryAreas/types'
import { SubmitHandler, useFormContext } from 'react-hook-form'
import FilterList from '@/components/content/FilterList'
import Input from '@/components/content/Input'
import SelectBoxBool from '@/components/content/SelectBoxBool'
import SelectBoxCity from '@/pages/master/deliveryAreas/components/SelectBoxCity'
import MultipleInput from '@/components/content/MultipleInput'
import styled from 'styled-components'
import { colorSystem } from '@/styles/theme'

export const INIT_FORM: GetDeliveryAreasReq = {
  zipcode: [],
  city: undefined,
  remoteArea: null,
  isHolidayDeliveryAvailable: null,
}

interface Props {
  isLoading: boolean
  onSave?: () => void
  onSubmit: SubmitHandler<GetDeliveryAreasReq>
}

function DeliveryAreasForm({ isLoading, onSave, onSubmit }: Props) {
  const { setValue, watch, reset, handleSubmit } = useFormContext<GetDeliveryAreasReq>()
  const values = watch()

  const searchDisabled = values.zipcode?.length === 0 && !values.city

  return (
    <Wrap>
      <FilterList
        isLoading={isLoading}
        list={[
          [
            {
              label: '우편번호',
              className: 'required-field',
              value: (
                <MultipleInput modalTitle="우편번호 검색" value={values.zipcode ?? []} onChange={(v) => setValue('zipcode', v)} maxSize={200} />
              ),
            },
            {
              label: '시구분',
              className: 'required-field',
              value: <SelectBoxCity value={values.city} onChange={(v) => setValue('city', v)} />,
            },
            {
              label: '구구분',
              value: <Input value={values.district} onChange={(v) => setValue('district', v)} />,
            },
          ],
          [
            {
              label: '읍면동',
              value: <Input value={values.town} onChange={(v) => setValue('town', v)} />,
            },
            {
              label: '배송리드타임',
              value: <Input type="number" block value={values.deliveryLeadDay} onChange={(v) => setValue('deliveryLeadDay', v)} />,
            },
            {
              label: '도서산간여부',
              value: <SelectBoxBool block value={values.remoteArea} onChange={(v) => setValue('remoteArea', v)} />,
            },
          ],
          [
            {
              label: '휴일배송 여부',
              value: <SelectBoxBool block value={values.isHolidayDeliveryAvailable} onChange={(v) => setValue('isHolidayDeliveryAvailable', v)} />,
            },
          ],
        ]}
        onReset={() => reset(INIT_FORM)}
        onSearch={handleSubmit(onSubmit)}
        onSave={onSave}
        searchDisabled={searchDisabled}
      />
    </Wrap>
  )
}

/**
 *  @memo
 *  기존의 FilterList는 and 조건으로 validation체크를 하나,
 *  요구사항에선 or 조건으로 체크하기에 상위에서 처리함
 *  이러한 케이스가 추가로 있을경우 FilterList에 required group 속성 추가 고려
 */
const Wrap = styled.div`
  .required-field {
    span {
      &:after {
        content: '*';
        color: ${colorSystem.text.common.highlight};
        position: relative;
        left: 2px;
        top: 3px;
      }
    }
  }
`

export default DeliveryAreasForm
